<template>
    <div class="container body fix-footer">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="card mt-5">
                    <div class="card-body text-center pt-5 pb-5">
                        <h1 class="far fa-check-circle green-check"></h1>
                        <h3 class="mt-3">{{ $t('registration.success') }}</h3>
                        <router-link to="/login" class="btn btn-lg btn-primary">Login</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'RegistrationSuccess'
  };
</script>

<style scoped>

</style>
